import posthog from "posthog-js";

const posthogKey = process.env.NEXT_PUBLIC_POSTHOG_KEY;
const posthogHost = process.env.NEXT_PUBLIC_POSTHOG_HOST;

if (posthogKey && posthogHost) {
  posthog.init(posthogKey, {
    api_host: posthogHost,
    defaults: "2025-05-24",
    person_profiles: "identified_only",
    // Cookieless until <PosthogConsent> resolves it from the login state.
    cookieless_mode: "on_reject",
    cross_subdomain_cookie: true,
  });

  posthog.register({ app_name: "admin-panel" });
}
